import './FakeCheckInput.less';

import React from 'react';
import ActiveCheckbox from 'nike-ui/src/icons/svg/active-checkbox-sv.svg';
import clsx from 'clsx';

function FakeCheckInput({ checked, className }) {
    return (
        <div className={clsx('fake-check-input', className, { checked })}>
            <ActiveCheckbox />
        </div>
    );
}

export default FakeCheckInput;
